import { AffiliateDetail, AffiliatePayload } from '@/services/affiliate/affiliate.types';
import { z } from 'zod';
import { AffiliateFormSchema } from './schema';

export type AffiliateFormValues = z.infer<typeof AffiliateFormSchema>;

export const affiliateFormDefaultValues: AffiliateFormValues = {
  userName: '',
  gender: 'M',
  businessType: '',
  image: undefined,
  fullName: '',
  affiliateNameFurigana: '',
  mobileNumber: '',
  emailAddress: '',
  dob: '',
  postalCode: '',
  prefecture: '',
  city: '',
  street: '',
  buildingNumber: '',
  ceoName: '',
  ceoNameFurigana: '',
  companyName: '',
  companyAddress: '',
};

const toDatePickerValue = (dob: AffiliateDetail['dob']) => {
  if (typeof dob !== 'number' || dob <= 0) return '';

  const date = new Date(dob);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString();
};

export const affiliateToFormValues = (affiliate: AffiliateDetail): AffiliateFormValues => ({
  ...affiliateFormDefaultValues,
  userName: affiliate.userName ?? '',
  fullName: `${affiliate.lastName ?? ''} ${affiliate.firstName ?? ''}`.trim(),
  affiliateNameFurigana: affiliate.affiliateNameFurigana ?? '',
  mobileNumber: affiliate.mobileNumber ?? '',
  emailAddress: affiliate.emailAddress ?? '',
  dob: toDatePickerValue(affiliate.dob),
  gender: affiliate.gender ?? 'M',
  city: affiliate.city ?? '',
  street: affiliate.street ?? '',
  buildingNumber: affiliate.buildingNo ?? '',
  postalCode: affiliate.postalCode ?? '',
  prefecture: affiliate.prefecture ?? '',
  businessType: affiliate.businessType ?? 'default',
  ceoName: affiliate.ceoName ?? '',
  ceoNameFurigana: affiliate.ceoNameFurigana ?? '',
  companyName: affiliate.companyName ?? '',
  companyAddress: affiliate.companyAddress ?? '',
  image: affiliate.image,
});

const splitFullName = (fullName: string) => {
  const [lastName = '', ...firstNameParts] = fullName.trim().split(/\s+/).filter(Boolean);
  return { lastName, firstName: firstNameParts.join(' ') };
};

export const formValuesToAffiliatePayload = (
  affiliateId: string,
  values: AffiliateFormValues,
  image: string,
  isCorporation: boolean,
): AffiliatePayload => {
  const { firstName, lastName } = splitFullName(values.fullName);

  return {
    affiliateId,
    firstName,
    lastName,
    emailAddress: values.emailAddress,
    mobileNumber: values.mobileNumber,
    gender: values.gender ?? 'M',
    postalCode: values.postalCode,
    affiliateNameFurigana: values.affiliateNameFurigana,
    prefecture: values.prefecture,
    city: values.city,
    street: values.street,
    buildingNo: values.buildingNumber ?? '',
    dob: values.dob ? new Date(values.dob).getTime() : 0,
    image,
    businessType: values.businessType ?? '',
    ceoName: isCorporation ? (values.ceoName ?? '') : '',
    ceoNameFurigana: isCorporation ? (values.ceoNameFurigana ?? '') : '',
    companyName: isCorporation ? (values.companyName ?? '') : '',
    companyAddress: isCorporation ? (values.companyAddress ?? '') : '',
  };
};
